import React from 'react';

import { ImageCard } from '../../../../components/three-image-block/image-card';

type ThreeImageCardContainerProps = {
    images: { imageId: number; src: string }[];
};

export const ThreeImageCardContainer: React.FC<ThreeImageCardContainerProps> = ({ images }) => {
    return (
        <div className="three-image-container">
            {images.map((image, index) => (
                <ImageCard
                    image={{
                        imageId: image.imageId,
                        src: image.src,
                    }}
                    key={index}
                />
            ))}
        </div>
    );
};
